import Table, { TableBody } from './table';
import TableCell, {
  MultiSelectorTableHeadCell,
  SortableTableHeadCell,
  TableHeadCell,
  type TableCellProps,
} from './table-cell/table-cell';
import { ClickableTableCell } from './table-cell/clickable-table-cell';
import TableRow, { type TableRowProps } from './table-row';
import { TableHead } from './table-head';
import { tableCellVariants } from './table-cell/table-cell-constants';

export default Table;
export {
  TableHead,
  TableBody,
  TableCell,
  TableHeadCell,
  MultiSelectorTableHeadCell,
  SortableTableHeadCell,
  TableRow,
  ClickableTableCell,
  tableCellVariants,
};
export type { TableRowProps, TableCellProps };
